<template>
  <div>
    <input type="file" @input="onFileChange" :accept="accept" ref="input" v-show="false" />
    <div class="clickable" @click="$refs.input.click()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="svg_icon" v-if="!$slots.default">
        <path
          :fill="fill"
          d="M16.5,6V17.5C16.5,19.71 14.71,21.5 12.5,21.5C10.29,21.5 8.5,19.71 8.5,17.5V5C8.5,3.62 9.62,2.5 11,2.5C12.38,2.5 13.5,3.62 13.5,5V15.5C13.5,16.05 13.05,16.5 12.5,16.5C11.95,16.5 11.5,16.05 11.5,15.5V6H10V15.5C10,16.88 11.12,18 12.5,18C13.88,18 15,16.88 15,15.5V5C15,2.79 13.21,1 11,1C8.79,1 7,2.79 7,5V17.5C7,20.54 9.46,23 12.5,23C15.54,23 18,20.54 18,17.5V6H16.5Z"
        />
      </svg>
      <slot v-else />
    </div>
  </div>
</template>

<script>
import { inject } from 'vue'

export default {
  props: {
    rules: {
      default: () => [],
      type: Array,
    },
    accept: String,
    value: {},
  },
  // inject: ['form'],
  data() {
    return {
      form: null,
      validationError: null,
    };
  },
  computed: {
    fill() {
      return this.validationError ? 'rgb(255, 82, 82)' : null;
    },
  },
  methods: {
    onFileChange(event) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;

      var file = files[0];

      if (file && this.accept && !this.accept.split(',').any(f => file.name.endsWith(f)))
        this.validationError = `File needs to one of extensions: ${this.accept}`;

      this.$emit('input', file);
      this.$refs.input.value = '';
    },
    validate() {
      this.validationError = this.rules
        .map(f => f(this.value))
        .find(f => f !== true);
      return !this.validationError;
    },
  },
  watch: {
    value() {
      this.validate();
    },
  },
  created() {
    try {
      this.form = inject('form');
      this.form && this.form.register(this);
    } catch (e) { console.log(e); }
  },
  beforeDestroy: function beforeDestroy() {
    this.form && this.form.unregister(this);
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisHvhUploadFile'] = this;
  },
}
</script>

<style lang="scss" scoped>
.svg_icon {
  height: 30px;
  cursor: pointer;
}
</style>